// Spring Air products (data + real per-size pricing from springair.com). Lead-gen catalog.
const A = "https://www.springair.com/cdn/shop/files/";
const SIZES = ["Twin XL", "Full", "Queen", "King", "California King"];

// v = { "Size": [price, compareAt] } - real per-size pricing (rounded to whole dollars).
function mk(name, firmness, image, v) {
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  const variants = {};
  SIZES.forEach((s) => (variants[s] = { price: v[s][0], compareAt: v[s][1] }));
  const [price, compareAt] = v["Twin XL"];
  return {
    slug, name, brand: "spring-air", category: "mattresses", price, compareAt, badge: "Save",
    priceFrom: true, firmness, type: "Hybrid", sizes: SIZES, variants, image, gallery: [image],
    description: `The ${name} by Spring Air is proudly made in the USA and available at MattressTown with local delivery, professional set-up and old-mattress removal.`,
  };
}

export const SPRINGAIR_CATALOG = [
  mk("Spring Air Back Supporter Amelia Firm", "Firm", A + "AmeliaFirmFront_1880x.jpg?v=1754310472", {
    "Twin XL": [700, 800], "Full": [825, 900], "Queen": [850, 1000], "King": [1100, 1300], "California King": [1100, 1300],
  }),
  mk("Spring Air Back Supporter Amelia Plush", "Plush", A + "AmeliaPlushFront_1880x.jpg?v=1754311444", {
    "Twin XL": [700, 800], "Full": [825, 900], "Queen": [850, 1000], "King": [1100, 1300], "California King": [1100, 1300],
  }),
  mk("Spring Air Back Supporter Hannah Firm", "Firm", A + "HannahFirmLifestyle_Front_1880x.jpg?v=1754312858", {
    "Twin XL": [800, 900], "Full": [975, 1050], "Queen": [1050, 1200], "King": [1300, 1500], "California King": [1300, 1500],
  }),
  mk("Spring Air Back Supporter Francesca Plush Eurotop", "Plush", A + "Francesca_ET_Lifestyle_1880x.jpg?v=1747689686", {
    "Twin XL": [1000, 1200], "Full": [1050, 1250], "Queen": [1200, 1400], "King": [1600, 1800], "California King": [1600, 1800],
  }),
  mk("Spring Air Back Supporter Makayla Firm", "Firm", A + "Makayla_Front_Lifestyle_1880x.jpg?v=1747687839", {
    "Twin XL": [1500, 1700], "Full": [1760, 1960], "Queen": [1900, 2100], "King": [2200, 2400], "California King": [2200, 2400],
  }),
  mk("Spring Air Copper Hybrid Firm Eurotop", "Firm", A + "Copper_ET_Front_Lifestyle_1880x.jpg?v=1747690427", {
    "Twin XL": [2200, 2700], "Full": [2800, 3300], "Queen": [2900, 3500], "King": [3300, 4100], "California King": [3300, 4100],
  }),
  mk("Spring Air Chattam & Wells Palermo Pillowtop", "Plush", A + "Chattam.Palermo_PT_Front_1880x.jpg?v=1749120624", {
    "Twin XL": [4800, 5600], "Full": [5450, 6300], "Queen": [5600, 6500], "King": [6300, 7500], "California King": [6300, 7500],
  }),
];
